import { render, staticRenderFns } from "./InterventionsInfo.vue?vue&type=template&id=867db662"
import script from "./InterventionsInfo.vue?vue&type=script&lang=js"
export * from "./InterventionsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports